<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal srm-modal--wide" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Events</h2>
        <p class="srm-sub">Events and plans permitted to scan at this gate</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-toolbar">
        <input type="text" class="srm-search" placeholder="Search events or plans…"
               [(ngModel)]="searchText" style="flex:1" />
        <button type="button" class="srm-link-btn" (click)="selectAll()">Select all events</button>
        <button type="button" class="srm-link-btn" (click)="clearAll()">Clear</button>
        <button type="button" class="srm-link-btn" (click)="expandAll()">Expand all</button>
      </div>

      <p class="srm-hint">
        Tick an event to allow the <strong>whole event</strong> (every plan, including any added
        later), or expand&nbsp;<span class="srm-chevron-hint">▸</span>&nbsp;it to pick individual plans.
      </p>

      <div class="srm-list srm-events">
        <div class="srm-list-scroll">
          <ng-container *ngFor="let ev of filteredEvents(); trackBy: trackEvent">
            <!-- Event row: chevron expands, checkbox/name selects the whole event. -->
            <div class="srm-event"
                 [class.srm-event--expanded]="isExpanded(ev)"
                 [class.srm-event--selected]="isEventSelected(ev)">
              <div class="srm-event-head">
                <button type="button" class="srm-expander"
                        [class.srm-expander--open]="isExpanded(ev)"
                        [disabled]="!ev.plans.length"
                        (click)="toggleExpand(ev)"
                        [attr.aria-label]="(isExpanded(ev) ? 'Collapse ' : 'Expand ') + ev.eventName">
                  <span class="srm-expander-icon" aria-hidden="true">▸</span>
                </button>

                <label class="srm-checkline" (click)="$event.stopPropagation()">
                  <input type="checkbox" [checked]="isEventSelected(ev)" (change)="toggleEvent(ev)"
                         [attr.aria-label]="'Select whole event ' + ev.eventName" />
                  <span class="srm-event-titles">
                    <span class="srm-event-name">{{ ev.eventName }}</span>
                    <span class="srm-event-meta" *ngIf="ev.description">{{ ev.description }}</span>
                  </span>
                </label>

                <span class="srm-plan-count" *ngIf="ev.plans.length"
                      (click)="toggleExpand(ev)">
                  {{ ev.plans.length }} plan{{ ev.plans.length === 1 ? '' : 's' }}
                  <ng-container *ngIf="selectedPlanCount(ev) as n">· {{ n }} picked</ng-container>
                </span>

                <button type="button" class="srm-link-btn srm-row-allplans"
                        *ngIf="ev.plans.length"
                        (click)="toggleAllPlans(ev)">
                  {{ allPlansSelected(ev) ? 'Clear plans' : 'All plans' }}
                </button>
              </div>

              <!-- Plans: shown only when expanded, visually nested under the event.
                   Disabled while the whole event is selected (the two are exclusive). -->
              <div class="srm-plans" *ngIf="isExpanded(ev)">
                <p class="srm-plans-note" *ngIf="isEventSelected(ev)">
                  Whole event selected — every plan is covered. Untick the event to choose individual plans.
                </p>
                <label class="srm-plan"
                       *ngFor="let plan of ev.plans; trackBy: trackPlan"
                       [class.srm-plan--selected]="isPlanSelected(ev, plan)"
                       [class.srm-plan--covered]="isEventSelected(ev)">
                  <input type="checkbox"
                         [checked]="isEventSelected(ev) || isPlanSelected(ev, plan)"
                         [disabled]="isEventSelected(ev)"
                         (change)="togglePlan(ev, plan)" />
                  <span class="srm-plan-name">{{ plan }}</span>
                </label>
              </div>
            </div>
          </ng-container>
          <div class="srm-empty" *ngIf="!filteredEvents().length">No events match your search.</div>
        </div>
      </div>
    </div>

    <footer class="srm-foot">
      <span class="srm-foot-count">{{ selectionSummary() }}</span>
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
